import { ArrowLeft, Building2, FileText, ListTodo, ReceiptText, Tags, Users } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { formatBRL } from "@yatta/domain";
import { Badge, Button, Card } from "../components/ui";
import { useCustomer360Directory } from "../data/supergestor-data";

export function Customer360Page() {
  const { id } = useParams();
  const query = useCustomer360Directory();
  const customer = query.data?.find((item) => item.id === id) ?? query.data?.[0];
  if (!customer)
    return (
      <Card>
        <p>Cliente não encontrado.</p>
      </Card>
    );
  const riskTone =
    customer.riskLevel === "HIGH" || customer.riskLevel === "CRITICAL"
      ? "danger"
      : customer.riskLevel === "MEDIUM"
        ? "warning"
        : "success";
  return (
    <div className="page-stack">
      <Link className="back-link" to="/clientes">
        <ArrowLeft size={16} /> Voltar
      </Link>
      <Card>
        <div className="customer-hero">
          <div className="large-avatar">
            {customer.kind === "LEGAL_ENTITY" ? <Building2 size={24} /> : <Users size={24} />}
          </div>
          <div>
            <p className="eyebrow">CUSTOMER 360</p>
            <h2>{customer.displayName}</h2>
            <p>
              {customer.kind} · {customer.identifier} · {customer.contact}
            </p>
          </div>
          <div className="customer-actions">
            <Button variant="secondary">Editar</Button>
            <Button>Nova operação</Button>
          </div>
        </div>
      </Card>
      <section className="metric-grid metric-grid-four">
        <article className="metric-card">
          <ReceiptText size={20} />
          <span>Saldo em aberto</span>
          <strong>{formatBRL(BigInt(customer.outstandingCents))}</strong>
          <small>{customer.openInvoices} cobrança(s)</small>
        </article>
        <article className="metric-card">
          <FileText size={20} />
          <span>Contratos e acordos</span>
          <strong>{customer.contracts + customer.agreements}</strong>
          <small>{customer.subscriptions} assinatura(s)</small>
        </article>
        <article className="metric-card">
          <ListTodo size={20} />
          <span>Tarefas abertas</span>
          <strong>{customer.openTasks}</strong>
          <small>Ações pendentes</small>
        </article>
        <article className="metric-card">
          <Tags size={20} />
          <span>Risco</span>
          <Badge tone={riskTone}>{customer.riskLevel}</Badge>
          <small>{customer.financialStatus}</small>
        </article>
      </section>
      <div className="two-column">
        <Card title="Relacionamentos">
          <div className="member-list">
            <div className="member-row">
              <div>
                <strong>Responsável financeiro</strong>
                <span>Relacionamento configurável e auditado</span>
              </div>
              <Badge tone="success">ATIVO</Badge>
            </div>
            <div className="member-row">
              <div>
                <strong>Contratos vinculados</strong>
                <span>Planos, vendas e locações no mesmo cadastro</span>
              </div>
              <Badge tone="info">{customer.contracts + customer.agreements}</Badge>
            </div>
          </div>
        </Card>
        <Card title="Linha do tempo">
          <ol className="timeline">
            <li>
              <strong>Customer 360 atualizado</strong>
              <span>Identidades, contratos e recebíveis consolidados</span>
            </li>
            <li>
              <strong>Última movimentação</strong>
              <span>
                {customer.lastEventAt
                  ? new Date(customer.lastEventAt).toLocaleString("pt-BR")
                  : "Sem evento"}
              </span>
            </li>
            <li>
              <strong>Verificação de duplicidade</strong>
              <span>Nenhuma fusão automática pendente</span>
            </li>
          </ol>
        </Card>
      </div>
    </div>
  );
}
